import { render } from "./Orders.vue?vue&type=template&id=72886cec&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=72886cec&lang=scss&scoped=true"

import exportComponent from "/var/www/html/OrderUser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72886cec"]])

export default __exports__